import { convertUTCToLocal } from "@/utility/dateHelper";

export const GetFormattedInventory = (apiResponse = {}) => {
    const {
        data,
        totalRecords = '',
        totalPages = '',
        pageSize = '',
        currentPage = '',
        activeCount = '',

    } = apiResponse;

    const formattedInventory = data?.map(GetInventory);
    return {
        data: formattedInventory,
        totalRecords: (data && data.length > 0) ? totalRecords : 0,
        totalPages,
        pageSize,
        currentPage,
        activeCount,
    };
};

// Helper function to map individual items
const GetInventory = (item = {}) => {
    const {
        productId = 0,
        warehouseId = 0,
        productCategory = "",
        gtin = "",
        parentId = "",
        stock = "",
        daysOnStock = 0,
        lastUpdated = "",
    } = item;

    return {
        uuid: `${productId}_${warehouseId}`,
        productId,
        warehouseId,
        productCategory,
        gtin,
        parentId,
        stock,
        daysOnStock,
        lastUpdated: convertUTCToLocal(lastUpdated),
    };
};
